import { Navigate, Outlet, useLocation } from "react-router";
import { PAY_COMPONENT_IMPORT_BASE_PATH } from "../config";
import type { WizardState } from "../types";
import { wizardRequiresUpload } from "../utils/wizardRequiresUpload";

export interface WizardRouteGuardProps {
  state: WizardState;
  isCommitting: boolean;
}

/**
 * Redirects deep-linked wizard routes back to Upload when required wizard state
 * is missing and session restore could not recover it (#228 fallback).
 */
export function WizardRouteGuard({ state, isCommitting }: WizardRouteGuardProps) {
  const { pathname } = useLocation();
  const suffix = pathname.replace(PAY_COMPONENT_IMPORT_BASE_PATH, "");

  if (wizardRequiresUpload(suffix, state, isCommitting)) {
    return <Navigate to={PAY_COMPONENT_IMPORT_BASE_PATH} replace />;
  }

  return <Outlet />;
}
